import Partition from "molecules/partition";
import React from "react";

const audit = [
  {
    name: "Mr. Rajamani Shankar",
    nature: "Non-Executive Independent Director",
    designation: "Chairman",
  },
  {
    name: "Ms. Alka J Dangash",
    nature: "Non-Executive Independent Director",
    designation: "Member",
  },
  {
    name: "Mr. Amandeep Panwar",
    nature: "Chairman and Managing Director",
    designation: "Member",
  },
];

const stakeholders = [
  {
    name: "Ms. Sarita Bahl",
    nature: "Non-Executive Independent Director",
    designation: "Chairperson",
  },
  {
    name: "Mr. Vijay Nadiminti",
    nature: "Non-Executive Non-Independent Director",
    designation: "Member",
  },
  {
    name: "Mr. Rishabh Choudhary",
    nature: "Whole Time Director",
    designation: "Member",
  },
];

const nomination = [
  {
    name: "Ms. Alka J Dangash",
    nature: "Non-Executive Independent Director",
    designation: "Chairperson",
  },
  {
    name: "Ms. Sarita Bahl",
    nature: "Non-Executive Independent Director",
    designation: "Member",
  },
  {
    name: "Mr. Rajamani Shankar",
    nature: "Non-Executive Independent Director",
    designation: "Member",
  },
];

const CommitteeTable = ({ title , members } : {title  :string, members : any[]}) => (
  <div className="mt-6 mb-4 border border-green rounded-lg overflow-hidden shadow-sm">
    <h3 className="bg-green text-lg font-semibold text-white uppercase px-6 py-3 border-b border-gray-300">
      {title}
    </h3>
    <div className="overflow-x-auto">
    <table className="min-w-full text-left text-md text-black">
      <thead className="bg-green-100 text-green-900">
        <tr>
          <th className="px-6 py-3">Name</th>
          <th className="px-6 py-3">Nature</th>
          <th className="px-6 py-3">Designation</th>
        </tr>
      </thead>
      <tbody>
        {members.map((member : any, idx : number) => (
          <tr
            key={idx}
          >
            <td className="px-6 py-3">{member.name}</td>
            <td className="px-6 py-3">{member.nature}</td>
            <td className="px-6 py-3">{member.designation}</td>
          </tr>
        ))}
      </tbody>
    </table>
    </div>
  </div> 
);

export default function CommiteeContent () {
  return (
    <>
    <div className="bg-gradient-to-r from-[#5D6A5D] to-[#193C34] w-full h-[64px] md:h-[80px] xl:h-[100px] 2xl:h-[90px]"></div>
    <section  className="bg-cream3 relative">
      
      <div className="p-6 max-w-5xl mx-auto text-[#101828]">
        <Partition color="dark" text="Commitees" />
      
        <CommitteeTable title="Audit Committee" members={audit} />
        <CommitteeTable title="Stakeholders Relationship Committee" members={stakeholders} />
        <CommitteeTable title="Nomination and Remuneration Committee" members={nomination} />
      </div>
    </section>
    </>
  );
};